import React, { useState, useEffect } from 'react';
import './App.css';

function App() {
  // States for input fields
  const [days, setDays] = useState(0);
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);

  // States for countdown
  const [timeLeft, setTimeLeft] = useState(0);
  const [running, setRunning] = useState(false);
  const [started, setStarted] = useState(false); // tracks if countdown has started at least once

  // Handle Start Button
  const handleStart = () => {
    const total =
      days * 24 * 60 * 60 +
      hours * 60 * 60 +
      minutes * 60 +
      seconds;

    if (total > 0) {
      setTimeLeft(total);
      setRunning(true);
      setStarted(true); // mark that countdown has begun
    }
  };

  // Effect for timer countdown
  useEffect(() => {
    if (!running) return;

    const intervalId = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(intervalId);
          setRunning(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, [running]);

  // Convert seconds into d:h:m:s
  const d = Math.floor(timeLeft / (24 * 3600));
  const h = Math.floor((timeLeft % (24 * 3600)) / 3600);
  const m = Math.floor((timeLeft % 3600) / 60);
  const s = timeLeft % 60;

  return (
    <div className="container">
      <h1>Countdown Timer</h1>

      <div className="inputs">
        <input
          type="number"
          min="0"
          placeholder="Days"
          onChange={(e) => setDays(parseInt(e.target.value) || 0)}
        />
        <input
          type="number"
          min="0"
          placeholder="Hours"
          onChange={(e) => setHours(parseInt(e.target.value) || 0)}
        />
        <input
          type="number"
          min="0"
          placeholder="Minutes"
          onChange={(e) => setMinutes(parseInt(e.target.value) || 0)}
        />
        <input
          type="number"
          min="0"
          placeholder="Seconds"
          onChange={(e) => setSeconds(parseInt(e.target.value) || 0)}
        />
        <button onClick={handleStart}>Start</button>
      </div>

      <div className="timer-display">
        {running && timeLeft > 0 ? (
          `${d} days : ${h} hours : ${m} minutes : ${s} seconds`
        ) : !running && started && timeLeft === 0 ? (
          <span>Countdown finished!</span>
        ) : (
          <span>Start the countdown!</span>
        )}
      </div>
    </div>
  );
}

export default App;
